var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReceipt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 185.895,
    height: 184.085,
    viewBox: "0 0 185.895 184.085",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "receipt",
    transform: "translate(0.002 -2.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1300",
    "data-name": "Path 1300",
    d: "M426.667,197.743,439.06,185.35l6.2,6.2V36.633H426.667Z",
    transform: "translate(-271.754 -21.74)",
    fill: "#baff9f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1301",
    "data-name": "Path 1301",
    d: "M34.133,191.546l12.393-6.2,6.2,6.2V36.633H34.133Z",
    transform: "translate(-21.74 -21.74)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1302",
    "data-name": "Path 1302",
    d: "M60.926,185.35l16.442,18.59,16.446-18.59,20.734,18.59,19.782-18.59,16.446,18.59,16.443-18.59,16.446,18.59,15.491-12.393h3.1V36.633H59.733V191.546Z",
    transform: "translate(-38.045 -21.74)",
    fill: "#ebffe3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1303",
    "data-name": "Path 1303",
    d: "M178.938,11.033H17.828a9.3,9.3,0,0,0,0,18.59v-9.3H178.937v9.3a9.3,9.3,0,0,0,0-18.59Z",
    transform: "translate(-5.435 -5.435)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_713",
    "data-name": "Group 713",
    transform: "translate(0 2.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1304",
    "data-name": "Path 1304",
    d: "M173.5,27.286h-3.1v-9.3H15.491v9.3h-3.1a12.393,12.393,0,1,1,0-24.786H173.5a12.393,12.393,0,1,1,0,24.786ZM9.3,11.8H176.6v8.463A6.2,6.2,0,0,0,173.5,8.7H12.393a6.2,6.2,0,0,0-3.1,11.561V11.8Z",
    transform: "translate(0 -2.5)",
    fill: "#08cd34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1305",
    "data-name": "Path 1305",
    d: "M165.022,202.886l-18.59-18.59-18.59,18.59-18.59-18.59-18.59,18.59L72.074,184.3l-18.59,18.59L34.9,184.3l-9.3,9.291V86.967a3.1,3.1,0,0,1,6.2,0v91.665l3.1-3.1,18.59,18.59,18.59-18.59,18.59,18.59,18.59-18.59,18.59,18.59,18.59-18.59,18.59,18.59,18.59-18.59,3.1,3.1V34.3H31.8V62.181a3.1,3.1,0,0,1-6.2,0V28.1H192.907V193.591l-9.295-9.295Z",
    transform: "translate(-16.305 -18.805)",
    fill: "#08cd34"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    cx: 3.098,
    cy: 3.098,
    r: 3.098,
    transform: "translate(9.295 52.671)",
    fill: "#08cd34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1306",
    "data-name": "Path 1306",
    d: "M288.506,350.03H242.032a3.1,3.1,0,1,1,0-6.2h46.474a3.1,3.1,0,1,1,0,6.2Z",
    transform: "translate(-152.182 -219.903)",
    fill: "#08cd34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1307",
    "data-name": "Path 1307",
    d: "M412.7,350.037a3.07,3.07,0,0,1-2.852-4.275,3.554,3.554,0,0,1,.652-1.023,3.091,3.091,0,0,1,3.377-.651,3.585,3.585,0,0,1,1.023.651,3.21,3.21,0,0,1,.651,1.023,3.068,3.068,0,0,1-2.85,4.275Z",
    transform: "translate(-260.882 -219.91)",
    fill: "#08cd34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1308",
    "data-name": "Path 1308",
    d: "M331.172,230.563H284.7a3.1,3.1,0,0,1,0-6.2h46.474a3.1,3.1,0,0,1,0,6.2Z",
    transform: "translate(-179.358 -143.812)",
    fill: "#08cd34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1309",
    "data-name": "Path 1309",
    d: "M358.348,290.3H327.365a3.1,3.1,0,1,1,0-6.2h30.982a3.1,3.1,0,1,1,0,6.2Z",
    transform: "translate(-206.533 -181.858)",
    fill: "#08cd34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1310",
    "data-name": "Path 1310",
    d: "M248.228,290.3h-6.2a3.1,3.1,0,1,1,0-6.2h6.2a3.1,3.1,0,0,1,0,6.2Z",
    transform: "translate(-152.182 -181.858)",
    fill: "#08cd34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1311",
    "data-name": "Path 1311",
    d: "M288.506,170.83H242.032a3.1,3.1,0,0,1,0-6.2h46.474a3.1,3.1,0,1,1,0,6.2Z",
    transform: "translate(-152.182 -105.767)",
    fill: "#08cd34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1312",
    "data-name": "Path 1312",
    d: "M412.7,170.83a3.069,3.069,0,1,1,2.2-.9,3.069,3.069,0,0,1-2.2.9Z",
    transform: "translate(-260.883 -105.767)",
    fill: "#08cd34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1313",
    "data-name": "Path 1313",
    d: "M250.564,230.5a3.07,3.07,0,0,1-2.852-4.275,3.188,3.188,0,0,1,.652-1.023,3.109,3.109,0,1,1,2.2,5.3Z",
    transform: "translate(-157.616 -143.746)",
    fill: "#08cd34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1314",
    "data-name": "Path 1314",
    d: "M293.231,290.3a3.094,3.094,0,0,1-1.179-.248,3.583,3.583,0,0,1-1.021-.651,3.064,3.064,0,0,1-.9-2.2,3.253,3.253,0,0,1,.9-2.2,2.886,2.886,0,0,1,1.021-.651,3.094,3.094,0,0,1,3.378.651,3.259,3.259,0,0,1,.9,2.2,3.069,3.069,0,0,1-3.1,3.1Z",
    transform: "translate(-184.792 -181.865)",
    fill: "#08cd34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1315",
    "data-name": "Path 1315",
    d: "M109.357,231.961A15.51,15.51,0,0,1,93.866,216.47a3.1,3.1,0,0,1,6.2,0,9.3,9.3,0,0,0,16.4,6,4.52,4.52,0,0,0,1.026-3.425,5.085,5.085,0,0,0-1.926-3.465l-16.2-12.6a11.305,11.305,0,0,1-4.286-7.718,10.651,10.651,0,0,1,2.46-8.063,15.49,15.49,0,0,1,27.322,10,3.1,3.1,0,1,1-6.2,0,9.294,9.294,0,0,0-16.4-6,4.517,4.517,0,0,0-1.026,3.419,5.093,5.093,0,0,0,1.927,3.47l16.2,12.6a11.3,11.3,0,0,1,4.286,7.709,10.675,10.675,0,0,1-2.458,8.072A15.464,15.464,0,0,1,109.357,231.961Z",
    transform: "translate(-59.785 -116.635)",
    fill: "#08cd34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1316",
    "data-name": "Path 1316",
    d: "M131.1,226.6a3.1,3.1,0,0,1-3.1-3.1V167.731a3.1,3.1,0,1,1,6.2,0V223.5a3.1,3.1,0,0,1-3.1,3.1Z",
    transform: "translate(-81.525 -105.766)",
    fill: "#08cd34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1317",
    "data-name": "Path 1317",
    d: "M28.7,94.1a3.073,3.073,0,0,1-1.179-.218A4.481,4.481,0,0,1,26.5,93.2a3.6,3.6,0,0,1-.652-1.023A2.614,2.614,0,0,1,25.6,91a3.1,3.1,0,0,1,5.3-2.2,6.077,6.077,0,0,1,.371.5,1.691,1.691,0,0,1,.28.526,2.01,2.01,0,0,1,.186.557A4.341,4.341,0,0,1,31.8,91a3.123,3.123,0,0,1-.9,2.2,3.073,3.073,0,0,1-2.2.9Z",
    transform: "translate(-16.303 -56.918)",
    fill: "#08cd34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1318",
    "data-name": "Path 1318",
    d: "M196.057,90.932a3.107,3.107,0,0,1,3.1-3.1h0a3.108,3.108,0,0,1,3.1,3.1h0a3.108,3.108,0,0,1-3.1,3.1h0a3.107,3.107,0,0,1-3.1-3.1Zm-12.393,0a3.107,3.107,0,0,1,3.1-3.1h0a3.108,3.108,0,0,1,3.1,3.1h0a3.108,3.108,0,0,1-3.1,3.1h0A3.107,3.107,0,0,1,183.664,90.932Zm-12.393,0a3.107,3.107,0,0,1,3.1-3.1h0a3.108,3.108,0,0,1,3.1,3.1h0a3.108,3.108,0,0,1-3.1,3.1h0A3.107,3.107,0,0,1,171.271,90.932Zm-12.393,0a3.107,3.107,0,0,1,3.1-3.1h0a3.108,3.108,0,0,1,3.1,3.1h0a3.108,3.108,0,0,1-3.1,3.1h0A3.107,3.107,0,0,1,158.878,90.932Zm-12.393,0a3.107,3.107,0,0,1,3.1-3.1h0a3.108,3.108,0,0,1,3.1,3.1h0a3.108,3.108,0,0,1-3.1,3.1h0A3.107,3.107,0,0,1,146.485,90.932Zm-12.393,0a3.107,3.107,0,0,1,3.1-3.1h0a3.108,3.108,0,0,1,3.1,3.1h0a3.108,3.108,0,0,1-3.1,3.1h0a3.107,3.107,0,0,1-3.1-3.1Zm-12.393,0a3.107,3.107,0,0,1,3.1-3.1h0a3.108,3.108,0,0,1,3.1,3.1h0a3.108,3.108,0,0,1-3.1,3.1h0a3.107,3.107,0,0,1-3.1-3.1Zm-12.393,0a3.107,3.107,0,0,1,3.1-3.1h0a3.108,3.108,0,0,1,3.1,3.1h0a3.108,3.108,0,0,1-3.1,3.1h0a3.107,3.107,0,0,1-3.1-3.1Zm-12.393,0a3.107,3.107,0,0,1,3.1-3.1h0a3.108,3.108,0,0,1,3.1,3.1h0a3.108,3.108,0,0,1-3.1,3.1h0a3.107,3.107,0,0,1-3.1-3.1Zm-12.393,0a3.107,3.107,0,0,1,3.1-3.1h0a3.108,3.108,0,0,1,3.1,3.1h0a3.108,3.108,0,0,1-3.1,3.1h0a3.107,3.107,0,0,1-3.1-3.1Zm-12.393,0a3.107,3.107,0,0,1,3.1-3.1h0a3.108,3.108,0,0,1,3.1,3.1h0a3.108,3.108,0,0,1-3.1,3.1h0a3.107,3.107,0,0,1-3.1-3.1Zm-12.393,0a3.107,3.107,0,0,1,3.1-3.1h0a3.108,3.108,0,0,1,3.1,3.1h0a3.108,3.108,0,0,1-3.1,3.1h0a3.107,3.107,0,0,1-3.1-3.1Z",
    transform: "translate(-38.045 -56.851)",
    fill: "#08cd34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1319",
    "data-name": "Path 1319",
    d: "M472.43,94.055a3.074,3.074,0,0,1-1.178-.218,4.481,4.481,0,0,1-1.021-.681,3.607,3.607,0,0,1-.652-1.023,2.611,2.611,0,0,1-.246-1.177,4.131,4.131,0,0,1,.062-.62,1.952,1.952,0,0,1,.184-.557,1.7,1.7,0,0,1,.28-.526c.124-.188.248-.342.372-.5a3.574,3.574,0,0,1,1.021-.651,3.085,3.085,0,0,1,2.355,0,3.586,3.586,0,0,1,1.023.651,6.161,6.161,0,0,1,.371.5,1.7,1.7,0,0,1,.28.526,2.018,2.018,0,0,1,.186.557,4.365,4.365,0,0,1,.062.62,2.6,2.6,0,0,1-.248,1.177,3.627,3.627,0,0,1-.65,1.023,3.074,3.074,0,0,1-2.2.9Z",
    transform: "translate(-298.927 -56.876)",
    fill: "#08cd34"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceipt);
export default __webpack_public_path__ + "static/media/receipt.2129742974e4f9fcae13b8625ab540e8.svg";
export { ForwardRef as ReactComponent };